import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { money } from "@/lib/brand";

const included = ["A personalised cover and title", "50 to 150+ pages, at the length you choose", "A dedication, chapters and a final letter written from your answers", "Up to 10 of your photos, plus illustrations in a style you pick", "Your draft to read and edit online after you order"];
const extras = [["gift_box", "Gift box"], ["handwritten_note", "Handwritten note"], ["extra_copy", "Extra copy", " each"], ["express_delivery", "Express delivery"]];
export const BookOptions = ({ price, addons, error }) => <section id="editions" className="options-section" aria-labelledby="options-title" data-testid="product-editions">
  <div className="brand-container options-grid">
    <div className="options-buy" data-testid="classic-edition">
      <h2 id="options-title" className="display-l">What’s <em>included.</em></h2>
      <p className="options-name">The Keepsake Storybook</p>
      <p className="options-price" data-testid="classic-price">{price ? money(price) : "Price shown at checkout"}</p>
      <p className="options-format">Printed softcover</p>
      <Link to="/create/new" className="btn-primary" data-testid="classic-create-cta">Create Your Keepsake <ArrowRight size={16}/></Link>
      {error && <p className="options-note" data-testid="edition-pricing-note">Live pricing could not be loaded. You’ll see the current price before you pay.</p>}
    </div>
    <div className="options-detail">
      <ul className="options-included" data-testid="included-list">{included.map((item) => <li key={item}>{item}</li>)}</ul>
      {addons && <div className="options-extras" data-testid="addons-list">
        <p className="eyebrow">Optional extras at checkout</p>
        <ul>{extras.map(([key, label, suffix = ""]) => addons[key] ? <li key={key}><span>{label}</span><span>{money(addons[key])}{suffix}</span></li> : null)}</ul>
      </div>}
      <div className="options-soon" data-testid="hardcover-preview">
        <p className="eyebrow">Coming soon</p>
        <p>A premium hardcover edition. Not yet available to order.</p>
      </div>
    </div>
  </div>
</section>;
